// AI Generated Test
import { Component, forwardRef, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'form-field-material-switch',
    templateUrl: './form-field-material-switch.component.html',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormFieldMaterialSwitchComponent),
            multi: true,
        },
    ],
})
export class FormFieldMaterialSwitchComponent implements OnInit, ControlValueAccessor {
    @Input() name: string = '';
    @Input() color: string = 'label-primary';
    @Input() trueValue: any = true;
    @Input() falseValue: any = false;
    @Output() ngChange: EventEmitter<any> = new EventEmitter<any>();

    private _onChange = (value: any) => {};
    private _onTouched = () => {};
    public _value: any = false;

    constructor () {}

    ngOnInit (): void {
        this.trueValue = this.trueValue !== undefined ? this.trueValue : true;
        this.falseValue = this.falseValue !== undefined ? this.falseValue : false;
        this._value = this._value === this.trueValue ? this.trueValue : this.falseValue;
        this.color = this.color || 'label-primary';
    }

    get value (): any {
        return this._value;
    }

    set value (val: any) {
        if (val !== this._value) {
            this._value = val;
            this._onChange(val);
            this._onTouched();
        }
    }

    writeValue (value: any): void {
        this._value = value;
    }

    registerOnChange (fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched (fn: any): void {
        this._onTouched = fn;
    }

    setDisabledState (isDisabled: boolean): void {
        // Handle disabled state if needed
    }

    onClick (): void {
        if (this._value === this.trueValue) {
            this.value = this.falseValue;
        } else {
            this.value = this.trueValue;
        }
        this.onChange();
    }

    onInputChange (event: Event): void {
        const target = event.target as HTMLInputElement;
        this.value = target.checked ? this.trueValue : this.falseValue;
        this.onChange();
    }

    onChange (): void {
        this.ngChange.emit(this._value);
    }

    isChecked (): boolean {
        return this._value === this.trueValue;
    }
}
